import { IExtendedSearchData } from "src/api/server/extended-search.types";
import { FilterSection } from "src/components/pages/search/filter-section";
import { useSearchResultCount } from "src/components/pages/search/hooks/use-search-result-count";
import { ISearchRequestParamsOmitCountry } from "src/components/pages/search/search.types";
import { SortSection } from "src/components/pages/search/sort-section";
import { handleResetSearch } from "src/components/pages/search/store/actions";
import { getSearchState } from "src/components/pages/search/store/search-store";
import { getResetSelectedRanking } from "src/components/pages/search/utils/get-reset-selected-ranking";
import { getRouterLocale } from "src/utils/router/use-router-locale";

interface ISearchRefinementSectionProps {
    data: IExtendedSearchData;
    searchParams: ISearchRequestParamsOmitCountry | null;
}

export const SearchRefinementSection = ({ data, searchParams }: ISearchRefinementSectionProps) => {
    const {
        rankingsData: { rankings, relevanceRanking },
    } = data;

    const { resultCount, isFetching } = useSearchResultCount(searchParams);

    const resetSearchRefinementToDefaults = () => {
        const { selectedFigures, selectedRanking } = getSearchState();

        if (selectedRanking === null) {
            handleResetSearch({ country: getRouterLocale().country });
            return;
        }

        const resetSelectedRanking = getResetSelectedRanking({
            rankingsData: data.rankingsData,
            selectedFigures,
            currentSelectedRanking: selectedRanking,
        });

        handleResetSearch({
            country: getRouterLocale().country,
            selectedRanking: resetSelectedRanking,
            sortDirection: resetSelectedRanking.sortDirection,
        });
    };

    return (
        <>
            <FilterSection data={data} resultCount={resultCount} isLoading={isFetching} onReset={resetSearchRefinementToDefaults} />
            <SortSection
                resultCount={resultCount}
                rankings={rankings}
                relevanceRanking={relevanceRanking}
                userNumOfDownloads={data.userNumOfDownloads}
                figuresPicker={data.figuresPicker}
            />
        </>
    );
};
